// extracted by mini-css-extract-plugin
export default {"orderStatus":"OrderStatus_orderStatus__us7Aa","icons":"OrderStatus_icons__sT7w2","id":"OrderStatus_id__DXXCm"};